// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_xKS","select":"styles_select__CiLaT"};